module.exports = __webpack_public_path__ + "img/dark-green-rectangle-table-10.fcaade98.png";